
export default {
  /**
   * 活动类型
   */
  activityType: 1, // 代表汉英活动个人赛
  activityCourseType: 3, // 代表汉英课程
  /**
   * 登录code码
   */
  LOGINTYPE: '3', // 代表erp
  /**
  * 获取验证码状态
   */
  LOGINSMSTYPE: '7', // 登录
  /**
   * 跳转订单来源
   */
  registrantsOrder: '1', // 个人跳转
  registrantsSchoolOrder: '2', // 学校报名个人信息
  teamSchoolOrder: '3', // 学校报名团体信息
  /**
   * 默认赛季
   */
  defaultSeason: '', // 登录后由接口获取默认赛季并存储本地，刷新页面取本地缓存
  /**
   * 国赛赛程
   */
  raceScheduleFinal: '4',
  /**
   * 区域赛赛程
   */
  raceScheduleRegional: '2',
  /**
   * 判断学校整体参加个人考量是否上报
   */
  ENROLLMENT_NO: 3001, // 未提交
  ENROLLMENT_NO_PAY: 3002, // 已提交未支付
  ENROLLMENT_YES_PAY: 3003, // 已支付
  /**
   * 支付来源
   */
  PAY_ORDERSOURCE: 0, // 网站
  /**
   * 支付类型
   */
  PAY_ORDERTYPE: 0, // 网站
  /**
   * 商品ID
   */
  PRODUCT_SCHOOLPERSON: '1', // 学校报名个人赛
  /**
   * 产品规格类型Code码
   */
  PRODUCT_SPECSTYPE_CODE_SCHOOLPERSON: 1, // 学校报名个人赛
  /**
   * 产品规格类型内容Code码
   */
  PRODUCT_SPECSTYPE_VALUE_CODE_SCHOOLPERSON: 1, // 学校报名个人赛
  /**
   * 商品productFlag
   */
  APPLY_TEST_PAPER: 'APPLY_TEST_PAPER', // 个人赛申报考量
  /**
   * 开通方式
   */
  OPEN_TYPE_DATE: 1, // 开通日期
  OPEN_TYPE_DAYS: 2, // 开通天数
  OPEN_TYPE_DEFAULT: 3, // 产品默认方式
  /**
   * 赛程flag
   */
  TEAM_COMPETITION_REGISTRATION: 'TEAM_COMPETITION_REGISTRATION', // 团体赛报名
  INDIVIDUAL_PRELIMINARY: 'INDIVIDUAL_PRELIMINARY', // 初赛
  INDIVIDUAL_FINAL: 'INDIVIDUAL_FINAL', // 复赛
  CITY_REGIONAL_COMPETITION: 'CITY_REGIONAL_COMPETITION', // 城市赛
  NATIONAL_FINALS: 'NATIONAL_FINALS', // 全国总
  /**
   * 教师身份
   * 1管理员 2个人赛， 3团体赛 4社团
   */
  ADMINISTRATOR_ROLEID: '1',
  ADMINISTRATOR_INDIVIDUAL: '2',
  ADMINISTRATOR_TEAN: '3',
  ADMINISTRATOR_ASSOCIATION: '4',

  /**
   *  权限
   */
  // 赛务-个人赛
  MATCH_INDIVIDUAL_PRELIMINARY: 'MATCH_INDIVIDUAL_PRELIMINARY', // 初选
  MATCH_INDIVIDUAL_FINAL: 'MATCH_INDIVIDUAL_FINAL', // 复选
  MATCH_CITY_REGIONAL_COMPETITION: 'MATCH_CITY_REGIONAL_COMPETITION', // 区域决选
  MATCH_NATIONAL_FINALS: 'MATCH_NATIONAL_FINALS', // 总决选

  data_statistics: 'data_statistics', // 考量统计
  individual_gametime_manage: 'individual_gametime_manage', // 比赛时间管理
  examination_room_list: 'examination_room_list', // 区域决选考场管理
  national_finals_examination_room_list: 'national_finals_examination_room_list', // 国赛考场管理
  xibaozhizuo: 'xibaozhizuo', // 喜报制作

  b_school_management_1: 'b_school_management_1', // 待审核学校
  individual_school_considerations: 'individual_school_considerations', // 待审核试卷
  individual_school_considerations_1: 'individual_school_considerations_1', // 待寄出试卷
  individual_school_considerations_3: 'individual_school_considerations_3', // 待收回试卷
  product_management_1: 'product_management_1', // 待支付订单
  product_management_2: 'product_management_2', // 待发货订单
  product_management_5: 'product_management_5', // 待处理退款申请

  // 考务-个人赛
  SCORE_INDIVIDUAL_PRELIMINARY: 'SCORE_INDIVIDUAL_PRELIMINARY', // 初选
  SCORE_INDIVIDUAL_FINAL: 'SCORE_INDIVIDUAL_FINAL', // 复选
  SCORE_CITY_REGIONAL_COMPETITION: 'SCORE_CITY_REGIONAL_COMPETITION', // 区域决选
  SCORE_NATIONAL_FINALS: 'SCORE_NATIONAL_FINALS', // 总决选

  exercise_scores: 'exercise_scores', // 练习题
  reset_player_score: 'reset_player_score', // 重置选手成绩
  change_player_gametype: 'change_player_gametype', // 参赛方式管理

  // B端数据管理
  system_competition_management: 'system_competition_management', // 赛区管理
  system_school_infomation: 'system_school_infomation', // 学校管理
  individual_school_considerations_1_1: 'individual_school_considerations_1_1', // 待审核试卷
  b_school_management_1_1: 'b_school_management_1_1', // 待审核学校

  // C端数据管理
  c_player_registInfo: 'c_player_registInfo', // 用户管理
  c_player_teacherinfo: 'c_player_teacherinfo', // 指导教师管理
  feedback: 'feedback', // 意见反馈管理

  // 产品管理
  product_management: 'product_management', // 产品订单管理
  thesaurus_management: 'thesaurus_management', // 字库、练习题开通
  product_open: 'product_open', // 产品开通
  coupon: 'coupon', // 优惠券管理
  productcode_management: 'productcode_management', // 兑换码管理
  semi_final_form_code: 'semi_final_form_code', // 参赛码管理
  course_schoolorder_management: 'course_schoolorder_management', // 学校课程管理
  course_teacherorder_management: 'course_teacherorder_management', // 教师课程管理

  // 学术系统
  rm: 'rm', // 裁判系统
  paper: 'paper', // 试卷管理
  academic_font_management: 'academic_font_management', // 词库管理
  academic_course_management: 'academic_course_management', // 课程管理

  // 系统管理
  system_management_user: 'system_management_user', // 账号管理
  system_management_logs: 'system_management_logs', // 日志列表
  system_management_section: 'system_management_section', // 部门管理
  system_management_position: 'system_management_position', // 岗位管理
  system_management_authority: 'system_management_authority', // 权限管理
  system_management_dictionary: 'system_management_dictionary', // 字典管理
  season: 'season', // 赛季管理
  race: 'race', // 赛程管理
  banner: 'banner'

}
